import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { CSSTransition } from "react-transition-group";
import {useDispatch, useSelector} from "react-redux";
import {closeModal} from "@/Store/Slices/ModalSlice";
import BodyModal from "@/Modals/BodyModal";

const MainModal = () => {
  const isOpen = useSelector(state => state.modal.isOpen);
  const dispatch = useDispatch();

  const handleClose = () => dispatch(closeModal());

  const closeOnEscapeKeyDown = e => {
    if ((e.charCode || e.keyCode) === 27) {
      handleClose();
    }
  };

  useEffect(() => {
    document.body.addEventListener("keydown", closeOnEscapeKeyDown);
    return function cleanup() {
      document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
    };
  }, []);

  return ReactDOM.createPortal(
    <CSSTransition
      in={isOpen}
      unmountOnExit
      timeout={{ enter: 0, exit: 300 }}
    >
      <div className="modal" onClick={handleClose}>
        <div className="modal-content" onClick={e => e.stopPropagation()}>
          <div className="modal-header flex justify-end">
            {/*<h4 className="modal-title">*/}
            {/*  {props.title}*/}
            {/*</h4>*/}
            <button onClick={handleClose} className="button w-5">
              <img src="/images/close.svg" alt="close" />
            </button>
          </div>
          <BodyModal/>
        </div>
      </div>
    </CSSTransition>,
    document.getElementById("app")
  );
};

export default MainModal;
